export function formatCurrency(value, showSign = false) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '$0.00'
  const abs = Math.abs(num).toFixed(2)
  if (showSign) {
    // Ноль — без знака: «+$0.00» читается как «непонятно плюс или минус».
    if (num === 0) return '$0.00'
    return num > 0 ? `+$${abs}` : `-$${abs}`
  }
  return `$${abs}`
}

// Формат цены входа/выхода в дневнике: для дешёвых монет (0.02, 0.12) нужно
// МНОГО знаков после запятой, иначе цена неинформативна. Количество знаков
// зависит от величины цены.
export function formatPrice(price) {
  if (price == null || Number.isNaN(Number(price))) return '—'
  const p = Number(price)
  const abs = Math.abs(p)
  let digits
  if (abs >= 1000) digits = 2
  else if (abs >= 1) digits = 4
  else if (abs >= 0.01) digits = 6
  else if (abs >= 0.0001) digits = 8
  else digits = 10
  return p.toFixed(digits)
}

// PnL в дневнике — ровно 2 знака после запятой (по задаче: длинные числа
// вроде «+$0.05873142» читать неудобно). Округляем до сотых; если после
// округления выходит «−0.00» — показываем нейтральное «$0.00» без знака.
export function formatPnl(value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '$0.00'
  const abs = Math.abs(num).toFixed(2)
  if (abs === '0.00') return '$0.00'
  return `${num < 0 ? '-' : '+'}$${abs}`
}

// PnL РЕАЛЬНОГО счёта в дневнике — те же 2 знака после запятой, но БЕЗ
// округления сотых. toFixed(2) округляет: 0.18689647 → «0.19», т.е. рисует
// цифру, которой в реальном P&L нет. Здесь просто отбрасываем знаки после
// второго — «0.18» — и никогда не меняем вторую цифру (не округляем). Так
// показанные цифры — это ровно первые две цифры P&L (как просил владелец:
// «2 цифры, не более, точно как в P&L, не округлять»).
export function formatPnlNoRound(value) {
  const num = Number(value)
  if (!Number.isFinite(num)) return '$0.00'
  // toFixed(10) — десятичная запись без e-нотации; берём «целая.сотые».
  const abs = Math.abs(num).toFixed(10)
  const dot = abs.indexOf('.')
  const truncated = dot < 0 ? abs : abs.slice(0, dot + 3)
  if (truncated === '0.00' || truncated === '0.0' || truncated === '0') return '$0.00'
  return `${num < 0 ? '-' : '+'}$${truncated}`
}

export function getValueColor(value) {
  if (value > 0) return '#34D399'
  if (value < 0) return '#FF3B30'
  // Ноль (сделок за период не было) — нейтрально-серый, а не «застрявший» белый:
  // так понятно, что прибыли/убытка просто нет, а не что значение не окрашено.
  return '#8E8E93'
}
